// extracted by mini-css-extract-plugin
export default {"enterWordQuiz":"QuizEnterWord_enterWordQuiz__DTBah","question":"QuizEnterWord_question__VYO0x","img":"QuizEnterWord_img__2i84n","mobileInput":"QuizEnterWord_mobileInput__wUlff"};